module.exports = {
  language: 'Taal',
  selectLanguage: 'Selecteer Taal',
  charging: 'Opladen',
  notCharging: 'Niet Opladen',
  advanceSetting: 'Geavanceerde Instellingen',
  chargingDesc: 'Start opladen wanneer het batterijniveau lager is dan ',
  enabled: 'Ingeschakeld',
  disabled: 'Uitgeschakeld',
  onPowerRestore: 'Bij Stroomherstel',
  powerWakeDesc: '** Gebruik twee onafhankelijke USB-laders om de Pi & PiSugar respectievelijk op te laden, en houd de aan/uit-schakelaar van PiSugar aan. Het zal automatisch inschakelen wanneer de externe stroom wordt hersteld.',
  powerWakeDescFor3: 'PiSugar zal automatisch inschakelen wanneer externe stroom wordt hersteld.',
  powerWakeOffWarning: 'U heeft de wake-on-power-restore functie uitgeschakeld, gelieve geen externe stroom afzonderlijk aan de Raspberry Pi te leveren.',
  powerWakeOffTitle: 'Opmerking',
  confirmButtonText: 'Bevestigen',
  wakeUpFeature: 'Geplande Ontwaking',
  repeat: 'Herhalen',
  repeatEveryday: 'dagelijks herhalen.',
  repeatOn: 'herhalen op',
  checkAll: 'Alles Selecteren',
  clearAll: 'Alles Wissen',
  wakeUpDesc: 'Geplande ontwaking om',
  wakeUpOffDesc: 'Geplande ontwaking uit.',
  buttonFunction: 'Aangepaste Knopfunctie',
  singleTapLabel: 'Enkele Tik',
  doubleTapLabel: 'Dubbele Tik',
  longTapLabel: 'Lange Tik',
  singleTap: 'enkele tik',
  doubleTap: 'dubbele tik',
  longTap: 'lange tik',
  none: 'geen',
  edit: 'Bewerken',
  customShell: 'Aangepaste Shell',
  shutdown: 'Afsluiten',
  shellModalTitle: {
    single: 'Shell uit te voeren voor enkele tik',
    double: 'Shell uit te voeren voor dubbele tik',
    long: 'Shell uit te voeren voor lange tik'
  },
  shell: 'Shell',
  shellPlaceholder: 'Voer hier shell script in...',
  cancel: 'Annuleren',
  confirm: 'Bevestigen',
  triggered: 'Geactiveerd',
  safeShutdown: 'Veilig Afsluiten',
  batteryLevel: 'Batterijniveau',
  immediately: 'Onmiddellijk',
  secondsDelay: 'seconden vertraging',
  rtcTime: 'RTC Tijd',
  sysTime: 'SYS Tijd',
  syncTime: 'Tijd Synchroniseren',
  weekDay: {
    Monday: 'Maandag',
    Tuesday: 'Dinsdag',
    Wednesday: 'Woensdag',
    Thursday: 'Donderdag',
    Friday: 'Vrijdag',
    Saturday: 'Zaterdag',
    Sunday: 'Zondag'
  },
  weekDayShort: {
    Mon: 'Maa',
    Tue: 'Din',
    Wed: 'Woe',
    Thu: 'Don',
    Fri: 'Vri',
    Sat: 'Zat',
    Sun: 'Zon'
  },
  batteryInputProtect: 'Batterij Invoer Bescherming',
  batteryInputProtectDesc: 'Het oplaadproces stopt wanneer 60% ~ 80% van de batterij is bereikt, wat de levensduur van de batterij effectief kan verlengen.',
  antiMistouch: 'Anti Aanraking per Ongeluk',
  antiMistouchDesc: 'Wanneer anti-aanraking per ongeluk is ingeschakeld, moet de schakelaar worden ingedrukt en vastgehouden om te activeren.',
  softPoweroff: 'Zachte Uitschakeling',
  softPoweroffDesc: 'Het gebruik van de schakelknop om af te sluiten zal niet direct uitschakelen, het afsluitcommando zal worden uitgegeven door de software.',
  softPoweroffShell: 'Zachte Uitschakeling Shell',
  softPoweroffShellDesc: 'Shell uit te voeren wanneer zachte uitschakeling wordt geactiveerd.',
  changeLoginPassword: 'Inlogwachtwoord Wijzigen',
  username: 'Gebruikersnaam',
  password: 'Wachtwoord',
  passwordConfirm: 'Voer wachtwoord opnieuw in',
  usernameCannotBeEmpty: 'Gebruikersnaam mag niet leeg zijn',
  passwordCannotBeEmpty: 'Wachtwoord mag niet leeg zijn',
  passwordNotConsistent: 'Beide ingevoerde wachtwoorden moeten consistent zijn',
  usernameWithSpace: 'Gebruikersnaam mag geen spaties bevatten',
  passwordWithSpace: 'Wachtwoord mag geen spaties bevatten',
  changePasswordSuccess: 'De wijziging is voltooid.',
  loginDialog: 'Inloggen',
  login: 'Inloggen'
}



// WEBPACK FOOTER //
// ./src/locale/nl-NL.js